import * as React from 'react';
import styled from 'styled-components';
import { IconProps } from './icon_props';

export interface Props {
  className?: string;
  style?: React.CSSProperties;
}

const Svg = styled.svg`
  cursor: ${(props) => (props.onClick ? 'pointer' : 'none')}
`;

const IconAdd = (props: IconProps) => {
  const className = props?.className ?? '';
  const style = props?.style ?? {};
  const onClick = props?.onClick ?? undefined;

  return (
    <Svg onClick={onClick} style={style} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341c-119.275 0-216.341-97.046-216.341-216.341S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.295 472.341 256 472.341z" />
      <path d="M355.148 234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83 8.884-19.83 19.83v79.318h-79.318c-10.966 0-19.83 8.884-19.83 19.83s8.864 19.83 19.83 19.83h79.318v79.318c0 10.946 8.864 19.83 19.83 19.83s19.83-8.884 19.83-19.83v-79.318h79.318c10.966 0 19.83-8.884 19.83-19.83s-8.864-19.83-19.83-19.83z" />
    </Svg>
  );
};

export default IconAdd;
